import { forwardRef, PropsWithChildren } from "react";
import styles from "./article-paragraph.module.scss";
import Paragraph, { ParagraphProps } from "../paragraph";


export const ArticleParagraph = forwardRef<any, PropsWithChildren<ParagraphProps>>((props, ref) => {
  return <Paragraph size={props.size || 11} className={styles.paragraph} {...props} ref={ref}/>
});
